import { Injectable } from "@angular/core";
import { AngularFireList, AngularFireDatabase } from '@angular/fire/database';
import { BehaviorSubject, Subject, Observable, Subscription } from 'rxjs';
import { AngularFireStorage } from 'angularfire2/storage';
import { finalize, subscribeOn } from "rxjs/operators";
import { Auto, Sante } from './ModelCotations';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoadingController, ModalController } from '@ionic/angular';
import { SharedService } from '../sheared/sharedService.service';
import { authenticationService } from '../Authentication/authentication.service';
import { CotationService } from './cotation.service';
import { FactoryService } from '../historique/factory.service';


@Injectable({
  providedIn: 'root'
})


export class CotationIndivAccidentService  {

  loading2: HTMLIonLoadingElement
 subscrip=new Subscription
 tauxPrime=new BehaviorSubject<any[]>([]);
 fraisMedical=new BehaviorSubject<any[]>([]);
 ListAccessoire = new BehaviorSubject<any[]>([]);
 codeAssur:string
 private BaremeTamporaireIndiv=[
  {Jour_Min:1,Jour_Max:29,Taux_Prime:30},
  {Jour_Min:30,Jour_Max:59,Taux_Prime:40},
  {Jour_Min:60,Jour_Max:89,Taux_Prime:50},
  {Jour_Min:90,Jour_Max:179,Taux_Prime:65},
  {Jour_Min:180,Jour_Max:269,Taux_Prime:80},
  {Jour_Min:270,Jour_Max:366,Taux_Prime:100},
 ]

 RemiseIndiv=[
   {nb_min:10,nb_max:30,Taux:15},
   {nb_min:31,nb_max:60,Taux:20},
   {nb_min:61,nb_max:10000000000,Taux:25}
 ]
 constructor(private db: AngularFireDatabase, private storage: AngularFireStorage,
    private sharedService: SharedService, private authentic: authenticationService,
    private modalController:ModalController ,private _cotatService:CotationService,
    private fact:FactoryService,
    private loadingController: LoadingController) {
      this.codeAssur=this.fact.getData(201)
          this.getaccessoires();

  }
  calculPrimeDuree(laperiode:any[]):any{
   
    let value={
      mois3:"",prime3:0,acc3:0,Taxe3:0,css3:0,Ttc3:0,
      mois6:"",prime6:0,acc6:0,Taxe6:0,css6:0,Ttc6:0,
      mois12:"",prime12:0,acc12:0,Taxe12:0,css12:0,Ttc12:0,
      type:"indiv"
    }
    let primefraisMedoc=0
    let primeCapitaux=0
    let prime=0

    this.fact.getnbComponent().forEach(e =>{
      if(!isNaN(this.fact.getData(e).primeCapitaux)){
        primeCapitaux += this.fact.getData(e).primeCapitaux
      }
      if(!isNaN(this.fact.getData(e).primefraisMedoc)){
        primefraisMedoc +=  this.fact.getData(e).primefraisMedoc 
      }
      
    })
    prime=primeCapitaux+primefraisMedoc
    for (let index = 0; index < laperiode.length; index++) {  
      const element = laperiode[index];  
      if (element) {
        if (element=="3 mois") {
             value.mois3=element
              value.prime3=Math.round(this.BaremeTamporaireIndiv.filter(a => a.Jour_Min<=90 && a.Jour_Max>=90)[0].Taux_Prime*prime/100)      
         }else if (element=="6 mois"){  
             value.mois6=element
               value.prime6=Math.round(this.BaremeTamporaireIndiv.filter(a => a.Jour_Min<=180 && a.Jour_Max>=180)[0].Taux_Prime*prime/100)
         }else if(element=="12 mois"){
             value.mois12=element
               value.prime12=Math.round(prime)
         }
      }    
    }
    
    
      return value
    
    }
    
 async Taux_Prime(codeAss,itemObj){
  // this.loading2 = await this.loadingController.create({
  //   message: 'Chargement...',
  //   // duration: 2000,
  //   spinner: 'bubbles'
  // });

  // await this.loading2.present();
  
  this.subscrip = await this.db.list(`TauxClasIndiv/${codeAss}`, ref => ref.orderByChild("CodeClass")
 .equalTo(itemObj.CodeClass))
  .snapshotChanges(['child_added']).subscribe(
    (actions) => {
      const result = [];
      actions.forEach((action) => {

          result.push({
            capital_limit:action.payload.exportVal().capital_limit,
            garanties:action.payload.exportVal().garanties,
            taux_garanties:action.payload.exportVal().taux_garanties,
            valider:false
           
          });
          
        
      
      })    

     // this.loading2.dismiss()
      this.tauxPrime.next(result)
      this.subscrip.unsubscribe()
    }
  )
}

  
async FraisMedical(codeAss){
  this.loading2 = await this.loadingController.create({
    message: 'Chargement...',
    duration: 30000,
    mode:"ios",
    spinner: 'bubbles'
  });

  await this.loading2.present();
  this.subscrip = await this.db.list(`FraisMedIndiv/${codeAss}`)
  .snapshotChanges(['child_added']).subscribe(
    (actions) => {
      const result = [];
      actions.forEach((action) => {
    
          result.push({
            Prime:action.payload.exportVal().Prime,
            Capital:action.payload.exportVal().Capital,
            Codeclass:action.payload.exportVal().Codeclass,
            valider:false
            
          });
      

      })    
      
      this.fraisMedical.next(result)
      this.loading2.dismiss()
      this.subscrip.unsubscribe()
    }
  )
  //this.subscrip.unsubscribe()
}
  
calculRemise(_objetNette:any){
  let nbPers=0
  this.fact.getnbComponent().forEach(e =>{
    if (e>0) {
      nbPers += this.fact.getData(e).nbPers
    }
    
  })
  let v=this.RemiseIndiv.filter(e => e.nb_min <= nbPers && e.nb_max >= nbPers)
  
  if (v.length==0)  return _objetNette
  //let TauxRed=v[0].Taux
  if (_objetNette.prime3>0) {
    _objetNette.prime3=Math.round(_objetNette.prime3*(100-v[0].Taux)/100)
  } 
  if (_objetNette.prime6>0) {
    _objetNette.prime6=Math.round(_objetNette.prime6*(100-v[0].Taux)/100) 
  } 
  if (_objetNette.prime12>0){
    _objetNette.prime12=Math.round(_objetNette.prime12*(100-v[0].Taux)/100)

  }
   return _objetNette
}
 // INDIVIDUELLE ACCIDENTS
 async instNewIndividuelle(codeAssur:string,$key:string,$police) {
  this.fact.setData(150,[])
  let libelle_Activite=""
  let nbPers=""
  let capitalDeces=""
  let capitalIp="";
  let fraisMedoc=""
  this.fact.getnbComponent().forEach(e =>{
    if(!isNaN(this.fact.getData(e).primeCapitaux)){
      let Id_Indiv=this.fact.getData(e)
      libelle_Activite += Id_Indiv.libelle_Activite+"%"
      nbPers += Id_Indiv.nbPers+"%"
      capitalDeces +=Id_Indiv.valDece+"%"
      capitalIp +=Id_Indiv.valIp+"%"
      fraisMedoc += (isNaN(Id_Indiv.primefraisMedoc) ? 0: Id_Indiv.primefraisMedoc)+"%"
    }  
  })
      let indiv={
        emmeteur:"",
        libelle_Activite:libelle_Activite,
        nbpers: nbPers,
        capitalDeces: capitalDeces,
        capitalIp: capitalIp,
        fraisMedoc:fraisMedoc,
        icon:"../../../assets/img/indiv.png",
        dateInsert: this.sharedService.getTimeStampFromToday(),
        CodeAssur:codeAssur,
        Quittance:$key,
        Police:$police,
        type:"Individuelle"
      }
      if (this.fact.getnbComponent().length==0) return
      this.db.list(`Cotations/${this.authentic.profile.uid}/Individuelle`).push(indiv)
}

 calculAccessoire(_objetNette:any):any{
   let myacc=1500
  _objetNette.acc3=0; _objetNette.acc6=0; _objetNette.acc12=0
  this.ListAccessoire.subscribe((access) => {
    _objetNette.acc3= (_objetNette.prime3 !=0) ? access.filter(a => a.min <= _objetNette.prime3 && a.max >= _objetNette.prime3)[0].acc+myacc:0
    _objetNette.acc6= (_objetNette.prime6 !=0)? access.filter(a => a.min <= _objetNette.prime6 && a.max >= _objetNette.prime6)[0].acc+myacc:0
    _objetNette.acc12=(_objetNette.prime12 !=0)? access.filter(a => a.min <= _objetNette.prime12 && a.max >= _objetNette.prime12)[0].acc+myacc:0
 
    })
return _objetNette
}
 calculPrimeTTC(_objetNette:any,tauxTaxe:number):any{
  
    //#region TAXE ENREGISTREMENT
        _objetNette.Taxe3=Math.round((_objetNette.prime3+_objetNette.acc3)*tauxTaxe/100)
        _objetNette.Taxe6=Math.round((_objetNette.prime6+_objetNette.acc6)*tauxTaxe/100)
        _objetNette.Taxe12=Math.round((_objetNette.prime12+_objetNette.acc12)*tauxTaxe/100)
    //#endregion
    //#region TAXE CSS
        _objetNette.css3=Math.round((_objetNette.prime3+_objetNette.acc3)/100)
        _objetNette.css6=Math.round((_objetNette.prime6+_objetNette.acc6)/100)
        _objetNette.css12=Math.round((_objetNette.prime12+_objetNette.acc12)/100)
    //#endregion
    _objetNette.Ttc3=_objetNette.prime3 + _objetNette.acc3 + _objetNette.css3 + _objetNette.Taxe3
    _objetNette.Ttc6=_objetNette.prime6 + _objetNette.acc6 + _objetNette.css6 + _objetNette.Taxe6
    _objetNette.Ttc12=_objetNette.prime12 + _objetNette.acc12 + _objetNette.css12 + _objetNette.Taxe12

  return _objetNette
}
private getaccessoires() {
  //+this.codeAssur
  this.db.list("Accessoires/1010", ref => ref.orderByValue()).snapshotChanges(['child_added']).subscribe(
    (actions) => {
      const ListAccessoire = [];
      actions.forEach((action) => {
        ListAccessoire.push({
          acc: action.payload.exportVal().acc,
          min: action.payload.exportVal().min,
          max: action.payload.exportVal().max
        });
      })
      this.ListAccessoire.next(ListAccessoire)
      //return ListAssreurs
    }
  )
}
 

  
}



